import React, { useState, useMemo, useEffect } from "react";
import { EChartsOption } from "echarts";
import ReactEchart from "../../../../../../molecules/ReactEchart";

const DoughnutChart = React.memo((props: any) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const colors = ["#0D2F47", "#4C708D", "#e85d64", "#4DA6FF", "#163C56"];
  const data = useMemo(() => {
    return (
      props?.data?.map((record, index) => ({
        ...record,
        itemStyle: { color: colors[index % colors.length] }, // cycle through colors
      })) || []
    );
  }, [props?.data]);

  const legendOptions = useMemo<EChartsOption["legend"]>(() => {
    return isMobile
      ? {
          orient: "horizontal",
          bottom: 0,
          left: 0,
          itemGap: 22,
          itemWidth: 12,
          itemHeight: 12,
          textStyle: {
            fontSize: 12,
            color: "#666",
          },
          formatter: (name: string) => {
            const item = data.find((d) => d.name === name);
            return `${name}  ${item?.value || ""}`;
          },
        }
      : {
          orient: "vertical",
          right: "5%",
          top: "center",
          itemGap: 22,
          itemWidth: 12,
          itemHeight: 12,
          textStyle: { fontSize: 12, color: "#666" },
          formatter: (name: string) => {
            const item = data.find((d) => d.name === name);
            return `${name}  ${item?.value || ""}`;
          },
        };
  }, [isMobile, props?.data]);

  const chartOptions: EChartsOption = useMemo(
    () => ({
      tooltip: {
        trigger: "item",
        formatter: (params: any) => {
          return `${params.name}: ${params.value}`;
        },
      },
      legend: legendOptions,
      series: [
        {
          name: "Reasons for Moving",
          type: "pie",
          radius: isMobile ? ["40%", "55%"] : ["50%", "65%"],
          avoidLabelOverlap: false,
          label: {
            show: true,
            position: "center",
            formatter: (params) => `${params.value}`,
            fontSize: 24,
            fontWeight: "bold",
            color: "#0F3446",
          },
          emphasis: {
            label: {
              show: true,
              fontSize: 24,
              fontWeight: "bold",
            },
          },
          labelLine: { show: false },
          center: isMobile ? ["35%", "25%"] : ["25%", "55%"],
          data,
        },
      ],
    }),
    [isMobile, legendOptions]
  );

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        width: "100%",
        justifyContent: "space-between",
      }}
    >
      <div
        style={{
          width: isMobile ? "350px" : "500px",
          height: isMobile ? "500px" : "350px",
          position: "relative",
        }}
      >
        {props?.data?.length > 0 && (
          <ReactEchart
            options={chartOptions}
            style={{ width: "100%", height: "100%" }}
          />
        )}
      </div>
    </div>
  );
});

export default DoughnutChart;
